import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { getCopyKey } from '../config';
import { QuickActionCardProps } from '../types';

const QuickActionCard = ({ copyKey, isMobileCopy, children }: QuickActionCardProps) => (
    <Stack
        direction="column"
        justifyContent="spaceBetween"
        gap={{ default: '4', sm: '8' }}
        borderRadius="2xl"
        backgroundColor="white"
        padding={{ default: '4', sm: '5' }}
        minHeight={{ default: 'auto', md: '240px' }}
        width="100%"
        flexGrow={{ default: 0, md: 1 }}
        flexBasis={{ default: 'auto', md: 0 }}
        minWidth={0}
    >
        <Stack direction="column" gap="3" width="100%">
            <Text size="b_lg" fontWeight="bold">
                <I18n k={getCopyKey(`${copyKey}.title`, isMobileCopy)} />
            </Text>
            <Text color="bodySecondary">
                <I18n k={getCopyKey(`${copyKey}.description`, isMobileCopy)} />
            </Text>
        </Stack>
        <Stack width="100%" justifyContent="flexEnd">
            {children}
        </Stack>
    </Stack>
);

export { QuickActionCard };
export default QuickActionCard;
